import { config } from '../config';
import { authHeader } from '../helpers';
import axiosInstance from '../axiosInstance';

export const brokerService = {
  brokerClientGetById,
  brokerClientGetBalances,
  brokerClientSearch
};

function brokerClientGetById(id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.broker_server}/${id}`, requestOptions).then((responce) => {
    return responce.data;
  });
}

function brokerClientGetBalances(id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .get(`${config.broker_server}/${id}/balances`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function brokerClientSearch(query) {
  const url = `${config.broker_server}/search`;
  console.log('Requesting URL:', url);

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .post(url, query, requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error in brokerClientSearch:', error);
      throw error;
    });
}
